import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WidgetMenuButton } from '../Widget/WidgetNavigationView';
import { ChevronLeft } from "lucide-react";
import { Suspense, lazy, useState } from "react";
import IconButton from "../Buttons/iconButton";
import { FormWizardProvider, useFormWizardaUpdate, useFormWizardState } from "../../context/formWizardProvider";
import { MenuStep } from "../../Models/Wizard";
import MenuList from "./MenuList";
import Wizard from "../Wizard/Wizard";
import WizardItem from "../Wizard/WizardItem";
import { Modal, ModalContent } from "../Modal/modalWithoutAnimation";
import { useCallbacks } from "../../context/callbackProvider";
import { useControllableState } from "../Modal/vaul/use-controllable-state";
import AddressBookStep from "../AddressBook/AddressBookStep";
// History and Campaigns are only rendered after the user opens this menu
// and navigates to a sub-step. Lazy-loading keeps their components — plus
// the per-row UI they pull in transitively — out of every page's entry
// chunks (they leaked onto `/` because the menu is always mounted in the
// header). Wizard renders only the active StepName, so the suspense
// fallback never shows while the user is on the Menu step.
const HistoryList = lazy(() => import("../Pages/SwapHistory/History"));
const CampaignsComponent = lazy(() => import("../Pages/Campaigns").then(m => ({ default: m.CampaignsComponent })));
const CampaignDetailsComponent = lazy(() => import("../Pages/Campaigns/Details").then(m => ({ default: m.CampaignDetailsComponent })));
const Comp = () => {
    const { goBack, currentStepName } = useFormWizardState();
    const { goToStep } = useFormWizardaUpdate();
    const { onMenuNavigationChange } = useCallbacks();
    const [isOpen = false, setIsOpen] = useControllableState({
        onChange: () => {
            goToStep(MenuStep.Menu);
            onMenuNavigationChange('/');
        },
    });
    const [selectedCampaign, setSelectedCampaign] = useState(undefined);
    const handleModalOpenStateChange = (value) => {
        setIsOpen(value);
        if (value === false) {
            goToStep(MenuStep.Menu);
            onMenuNavigationChange("/");
        }
    };
    const goBackToMenuStep = () => {
        goToStep(MenuStep.Menu, "back");
        onMenuNavigationChange("/");
    };
    const handleGoToStep = (step, path) => {
        goToStep(step);
        if (path) {
            onMenuNavigationChange(path);
        }
    };
    return _jsx(_Fragment, { children: _jsxs("div", { className: "text-secondary-text cursor-pointer relative", children: [_jsx(WidgetMenuButton, { onClick: () => setIsOpen(true) }), _jsx(Modal, { isOpen: isOpen, setIsOpen: handleModalOpenStateChange, children: _jsx(ModalContent, { className: "pb-4", header: _jsxs("div", { className: "inline-flex items-center w-full", children: [goBack &&
                                    _jsx("div", { className: "-ml-2", children: _jsx(IconButton, { className: "inline-flex", onClick: goBack, icon: _jsx(ChevronLeft, { strokeWidth: "2" }) }) }), _jsx("h2", { className: "flex-1", children: currentStepName })] }), children: ({ closeModal }) => (_jsx("div", { className: "openpicker h-full", id: "virtualListContainer", children: _jsxs(Wizard, { wizardId: 'menuWizard', children: [_jsx(WizardItem, { StepName: MenuStep.Menu, inModal: true, children: _jsx(MenuList, { goToStep: handleGoToStep }) }), _jsx(WizardItem, { StepName: MenuStep.Transactions, GoBack: goBackToMenuStep, className: "h-full", inModal: true, children: _jsx(Suspense, { fallback: null, children: _jsx(HistoryList, { onNewTransferClick: () => { closeModal(); onMenuNavigationChange("/"); } }) }) }), _jsx(WizardItem, { StepName: MenuStep.Campaigns, GoBack: goBackToMenuStep, className: "h-full", inModal: true, children: _jsx(Suspense, { fallback: null, children: _jsx(CampaignsComponent, { onCampaignSelect: (campaign) => { handleGoToStep(MenuStep.CampaignDetails); setSelectedCampaign(campaign.name); } }) }) }), _jsx(WizardItem, { StepName: MenuStep.CampaignDetails, GoBack: () => { goToStep(MenuStep.Campaigns, "back"); onMenuNavigationChange("/campaigns"); }, className: "h-full", inModal: true, children: _jsx(Suspense, { fallback: null, children: _jsx(CampaignDetailsComponent, { campaignName: selectedCampaign }) }) }), _jsx(WizardItem, { StepName: MenuStep.AddressBook, GoBack: goBackToMenuStep, inModal: true, children: _jsx(AddressBookStep, { onBack: goBackToMenuStep }) })] }) })) }) })] }) });
};
const LayerswapMenu = () => {
    return (_jsx(FormWizardProvider, { noToolBar: true, hideMenu: true, initialStep: MenuStep.Menu, children: _jsx(Comp, {}) }));
};
export default LayerswapMenu;
